export default "__VITE_ASSET__Ozwmmj5s__"